import { render, staticRenderFns } from "./ForeignerInfo.vue?vue&type=template&id=065970d5"
import script from "./ForeignerInfo.vue?vue&type=script&lang=js"
export * from "./ForeignerInfo.vue?vue&type=script&lang=js"
import style0 from "./ForeignerInfo.vue?vue&type=style&index=0&id=065970d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports